export * from './department-add-edit.component';
export * from './department-list.component';